import {
  DataGridColumn,
  DataGridOptions,
  DataTable,
  DataTableColumn,
  DataTableOptions,
  DataType,
  DateFormat,
  Form,
  FormDialogMode,
  FormOptions,
  GlobalerisDataGrid,
  Section,
  UserPermission
} from '@globaleris/ui.library'
import React, { useEffect, useState } from 'react'
import i18n from '../../i18n'
import { getCustomerDomain } from '../../redux'
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core'
import { FormDialogDefinitionProps, useFormDialog } from '../../hooks'
import Page from '../../components/page/page'
import { useTranslation } from 'react-i18next'
import { Period, gridValuesGenerator } from '../../helpers/gridValuesGenerator/gridValuesGenerator'
import moment from 'moment'
import { toLocaleDate } from '../../helpers'
import { Edit } from '@material-ui/icons'

export const GeneratorTest: React.FC = () => {
  const [t] = useTranslation(['globalerisLibrary', 'translation', 'contracts'])
  const [data, setData] = useState<any[]>([])

  // const [formState, setFormState] = useState<any>({})
  // const [formEditState, setFormEditState] = useState<any>({})
  // const [strictMode, setStrictMode] = useState<boolean>(false)
  // const [period, setPeriod] = useState<Period | undefined>(undefined)
  // const [error, setError] = useState<string | null>(null)
  const [dialogOpen, setDialogOpen] = useState<'generate' | 'edit' | null>(null)

  const { openForm, CustomFormDialog, formProps, closeForm } = useFormDialog()

  interface formDependenciesProps {
    formState: any
    strictMode: boolean
    period: Period | undefined
    error: string | null
  }

  const initialFormDependencies = {
    formState: {},
    period: undefined,
    error: null,
    strictMode: false
  }

  const [formDependencies, setFormDependencies] =
    React.useState<formDependenciesProps>(initialFormDependencies)

  const columns: DataTableColumn[] = [
    {
      name: 'startDate',
      label: t('contracts:components.capacitiesTable.columns.startDate'),
      type: DataType.DATE
    },
    {
      name: 'endDate',
      label: t('contracts:components.capacitiesTable.columns.endDate'),
      type: DataType.DATE
    },
    {
      name: 'quantity',
      label: t('contracts:components.capacitiesTable.columns.rawMaterial'),
      type: DataType.NUMBER
    }
  ]

  const tableOptions: DataTableOptions = {
    i18n: t('globalerisLibrary:dataTable', { returnObjects: true }),
    search: true,
    elevation: 0,
    customInsertEditModal: true,
    // sortOrder: { name: 'endDate', direction: SortDirection.ASC },
    analytics: {
      customer: getCustomerDomain(),
      view: t('contracts:components.capacitiesTable.analytics')
    },
    canDelete: false,
    canEdit: false
  }

  // const searchFormDefinition: Section[] = [
  //   {
  //     title: 'GENERATE_TEST',
  //     inputs: [
  //       {
  //         name: 'period',
  //         label: 'Período',
  //         type: DataType.SELECT,
  //         selectOptions: [
  //           { value: 1, label: 'Diario' },
  //           { value: 3, label: 'Mensual' },
  //           { value: 4, label: 'Trimestral' },
  //           { value: 5, label: 'Anual' },
  //           { value: 6, label: 'Fijo' },
  //           { value: 7, label: 'Custom' }
  //         ],
  //         required: true,
  //         onChange: (period, formState) => {
  //           const isCustom = period === Period.Custom
  //           // setPeriod(+period)

  //           // setFormState(prevState => ({
  //           //   ...prevState,
  //           //   period: +period,
  //           //   startDate: isCustom ? null : prevState.startDate,
  //           //   endDate: isCustom ? null : prevState.endDate
  //           // }))
  //           console.log(period)
  //           setFormDependencies(prevState => ({
  //             ...prevState,
  //             period: +period,
  //             formState: {
  //               ...prevState.formState,
  //               period: +period,
  //               startDate: isCustom ? null : prevState.formState.startDate,
  //               endDate: isCustom ? null : prevState.formState.endDate
  //             }
  //           }))
  //         }
  //         // minDate: formDependencies.formState?.startDate
  //         //   ? moment(formDependencies.formState.startDate).toISOString()
  //         //   : undefined,
  //         // onChange: handleEndDateChange
  //       },
  //       {
  //         name: 'strictMode',
  //         label: 'Modo Estricto (Exacto?)',
  //         type: DataType.BOOLEAN,
  //         required: true,
  //         onChange: (mode, formState) => {
  //           // setStrictMode(!!mode)
  //           // setFormState(prevState => ({ ...prevState, strictMode: !!mode }))

  //           setFormDependencies(prevState => ({
  //             ...prevState,
  //             strictMode: !!mode
  //           }))
  //         }
  //       },
  //       {
  //         name: 'startDate',
  //         label: i18n.t('translation:components.searchFilter.inputs.startDate'),
  //         type: DataType.DATE,
  //         required:
  //           !formDependencies.period ||
  //           (formDependencies.period && formDependencies.period !== Period.Custom),
  //         readOnly: formDependencies.period && formDependencies.period === Period.Custom,
  //         onChange(value, formState) {
  //           // setFormState(prevState => ({ ...prevState, startDate: value }))
  //           setFormDependencies(prevState => ({
  //             ...prevState,
  //             formState: {
  //               ...prevState.formState,
  //               startDate: value
  //             }
  //           }))
  //         }
  //       },
  //       {
  //         name: 'endDate',
  //         label: i18n.t('translation:components.searchFilter.inputs.endDate'),
  //         type: DataType.DATE,
  //         required:
  //           !formDependencies.period ||
  //           (formDependencies.period && formDependencies.period !== Period.Custom),
  //         readOnly: formDependencies.period && formDependencies.period === Period.Custom,
  //         onChange(value, formState) {
  //           // setFormState(prevState => ({ ...prevState, endDate: value }))
  //           setFormDependencies(prevState => ({
  //             ...prevState,
  //             formState: {
  //               ...prevState.formState,
  //               endDate: value
  //             }
  //           }))
  //         }
  //         // minDate: formDependencies.formState?.startDate
  //         //   ? moment(formDependencies.formState.startDate).toISOString()
  //         //   : undefined,
  //         // onChange: handleEndDateChange
  //       },
  //       {
  //         name: 'customNumRows',
  //         label: 'Cantidad de filas',
  //         type: DataType.NUMBER,
  //         required: formDependencies.period && formDependencies.period === Period.Custom,
  //         readOnly: !(formDependencies.period && formDependencies.period === Period.Custom),
  //         helpText: 'Número de filas a generar. Sólo para periodos custom.',
  //         onChange: (value, formState) => {
  //           // setFormState(prevState => ({ ...prevState, customNumRows: +value }))
  //           setFormDependencies(prevState => ({
  //             ...prevState,
  //             formState: {
  //               ...prevState.formState,
  //               customNumRows: +value
  //             }
  //           }))
  //         }
  //       },
  //       {
  //         name: 'fixedQuantity',
  //         label: 'Cantidad fija',
  //         type: DataType.NUMBER,
  //         helpText: 'Se asignará esta cantidad a todas las filas.',
  //         onChange: (value, formState) => {
  //           // setFormState(prevState => ({ ...prevState, fixedQuantity: +value }))
  //           setFormDependencies(prevState => ({
  //             ...prevState,
  //             formState: {
  //               ...prevState.formState,
  //               fixedQuantity: +value
  //             }
  //           }))
  //         }
  //       },
  //       {
  //         name: 'helpMessage',
  //         labelTitle:
  //           "'El período de fechas deberá ser divisible en el período seleccionado. Ejemplo: Trimestral 2023-01-01 - 2023-03-31'",
  //         type: DataType.LABEL,
  //         display: formDependencies.strictMode
  //       },
  //       {
  //         name: 'errorMessage',
  //         labelTitle: formDependencies.error ?? '',
  //         type: DataType.LABEL,
  //         labelHighlighted: true,
  //         display: !!formDependencies.error
  //       }
  //     ]
  //   }
  // ]
  const generateFormDefinition =
    React.useMemo<FormDialogDefinitionProps>((): FormDialogDefinitionProps => {
      return {
        id: 'GENERATE_TEST',
        inputs: [
          {
            name: 'period',
            label: 'Período',
            type: DataType.SELECT,
            selectOptions: [
              { value: 1, label: 'Diario' },
              { value: 3, label: 'Mensual' },
              { value: 4, label: 'Trimestral' },
              { value: 5, label: 'Anual' },
              { value: 6, label: 'Fijo' },
              { value: 7, label: 'Custom' }
            ],
            required: true,
            onChange: (period, formState) => {
              const isCustom = period === Period.Custom
              // setPeriod(+period)

              // setFormState(prevState => ({
              //   ...prevState,
              //   period: +period,
              //   startDate: isCustom ? null : prevState.startDate,
              //   endDate: isCustom ? null : prevState.endDate
              // }))
              setFormDependencies(prevState => ({
                ...prevState,
                period: +period,
                formState: {
                  ...prevState.formState,
                  period: +period,
                  startDate: isCustom ? null : prevState.formState.startDate,
                  endDate: isCustom ? null : prevState.formState.endDate
                }
              }))
            }
            // minDate: formDependencies.formState?.startDate
            //   ? moment(formDependencies.formState.startDate).toISOString()
            //   : undefined,
            // onChange: handleEndDateChange
          },
          {
            name: 'strictMode',
            label: 'Modo Estricto (Exacto?)',
            type: DataType.BOOLEAN,
            required: true,
            onChange: (mode, formState) => {
              // setStrictMode(!!mode)
              // setFormState(prevState => ({ ...prevState, strictMode: !!mode }))

              setFormDependencies(prevState => ({
                ...prevState,
                strictMode: !!mode
              }))
            }
          },
          {
            name: 'startDate',
            label: i18n.t('translation:components.searchFilter.inputs.startDate'),
            type: DataType.DATE,
            required:
              !formDependencies.period ||
              (formDependencies.period && formDependencies.period !== Period.Custom),
            readOnly: formDependencies.period && formDependencies.period === Period.Custom,
            onChange(value, formState) {
              // setFormState(prevState => ({ ...prevState, startDate: value }))
              setFormDependencies(prevState => ({
                ...prevState,
                formState: {
                  ...prevState.formState,
                  startDate: value
                }
              }))
            }
          },
          {
            name: 'endDate',
            label: i18n.t('translation:components.searchFilter.inputs.endDate'),
            type: DataType.DATE,
            required:
              !formDependencies.period ||
              (formDependencies.period && formDependencies.period !== Period.Custom),
            readOnly: formDependencies.period && formDependencies.period === Period.Custom,
            onChange(value, formState) {
              // setFormState(prevState => ({ ...prevState, endDate: value }))
              setFormDependencies(prevState => ({
                ...prevState,
                formState: {
                  ...prevState.formState,
                  endDate: value
                }
              }))
            }
            // minDate: formDependencies.formState?.startDate
            //   ? moment(formDependencies.formState.startDate).toISOString()
            //   : undefined,
            // onChange: handleEndDateChange
          },
          {
            name: 'customNumRows',
            label: 'Cantidad de filas',
            type: DataType.NUMBER,
            required: formDependencies.period && formDependencies.period === Period.Custom,
            readOnly: !(formDependencies.period && formDependencies.period === Period.Custom),
            helpText: 'Número de filas a generar. Sólo para periodos custom.',
            onChange: (value, formState) => {
              // setFormState(prevState => ({ ...prevState, customNumRows: +value }))
              setFormDependencies(prevState => ({
                ...prevState,
                formState: {
                  ...prevState.formState,
                  customNumRows: +value
                }
              }))
            }
          },
          {
            name: 'fixedQuantity',
            label: 'Cantidad fija',
            type: DataType.NUMBER,
            helpText: 'Se asignará esta cantidad a todas las filas.',
            onChange: (value, formState) => {
              // setFormState(prevState => ({ ...prevState, fixedQuantity: +value }))
              setFormDependencies(prevState => ({
                ...prevState,
                formState: {
                  ...prevState.formState,
                  fixedQuantity: +value
                }
              }))
            }
          },
          {
            name: 'helpMessage',
            labelTitle:
              "'El período de fechas deberá ser divisible en el período seleccionado. Ejemplo: Trimestral 2023-01-01 - 2023-03-31'",
            type: DataType.LABEL,
            display: formDependencies.strictMode
          },
          {
            name: 'errorMessage',
            labelTitle: formDependencies.error ?? '',
            type: DataType.LABEL,
            labelHighlighted: true,
            display: !!formDependencies.error
          }
        ]
      }
    }, [formDependencies])

  // eslint-disable-next-line react-hooks/exhaustive-deps

  // const editDialogFormDefinition = [
  //   {
  //     title: 'EDIT_TEST',
  //     inputs: [
  //       {
  //         name: 'startDate',
  //         label: i18n.t('translation:components.searchFilter.inputs.startDate'),
  //         type: DataType.DATE,
  //         required: true,
  //         maxDate: formDependencies.formState.endDate,
  //         onChange: (value, formState) => {
  //           console.log(value)
  //           // setFormEditState(prevState => ({ ...prevState, startDate: moment(value).toDate() }))
  //           setFormDependencies(prevState => ({
  //             ...prevState,
  //             formState: {
  //               ...prevState.formState,
  //               startDate: moment(value).toDate()
  //             }
  //           }))
  //         }
  //       },
  //       {
  //         name: 'endDate',
  //         label: i18n.t('translation:components.searchFilter.inputs.endDate'),
  //         type: DataType.DATE,
  //         required: true,
  //         minDate: formDependencies.formState.startDate,
  //         onChange: (value, formState) => {
  //           // setFormEditState(prevState => ({ ...prevState, endDate: moment(value).toDate() }))
  //           setFormDependencies(prevState => ({
  //             ...prevState,
  //             formState: {
  //               ...prevState.formState,
  //               endDate: moment(value).toDate()
  //             }
  //           }))
  //         }
  //         // minDate: formDependencies.formState?.startDate
  //         //   ? moment(formDependencies.formState.startDate).toISOString()
  //         //   : undefined,
  //         // onChange: handleEndDateChange
  //       },
  //       {
  //         name: 'quantity',
  //         label: 'Cantidad',
  //         type: DataType.NUMBER
  //         // onChange: (value, formState) => {
  //         //   setFormState(prevState => ({ ...prevState, fixedQuantity: +value }))
  //         // }
  //       }
  //     ]
  //   }
  // ]
  const editDialogFormDefinition =
    React.useMemo<FormDialogDefinitionProps>((): FormDialogDefinitionProps => {
      return {
        id: 'EDIT_TEST',
        inputs: [
          {
            name: 'startDate',
            label: i18n.t('translation:components.searchFilter.inputs.startDate'),
            type: DataType.DATE,
            required: true,
            maxDate: formDependencies.formState.endDate,
            onChange: (value, formState) => {
              // setFormEditState(prevState => ({ ...prevState, startDate: moment(value).toDate() }))
              setFormDependencies(prevState => ({
                ...prevState,
                formState: {
                  ...prevState.formState,
                  startDate: moment(value).toDate()
                }
              }))
            }
          },
          {
            name: 'endDate',
            label: i18n.t('translation:components.searchFilter.inputs.endDate'),
            type: DataType.DATE,
            required: true,
            minDate: formDependencies.formState.startDate,
            onChange: (value, formState) => {
              // setFormEditState(prevState => ({ ...prevState, endDate: moment(value).toDate() }))
              setFormDependencies(prevState => ({
                ...prevState,
                formState: {
                  ...prevState.formState,
                  endDate: moment(value).toDate()
                }
              }))
            }
            // minDate: formDependencies.formState?.startDate
            //   ? moment(formDependencies.formState.startDate).toISOString()
            //   : undefined,
            // onChange: handleEndDateChange
          },
          {
            name: 'quantity',
            label: 'Cantidad',
            type: DataType.NUMBER
            // onChange: (value, formState) => {
            //   setFormState(prevState => ({ ...prevState, fixedQuantity: +value }))
            // }
          }
        ]
      }
    }, [formDependencies])

  // eslint-disable-next-line react-hooks/exhaustive-deps

  const handleGenerateClose = data => {
    if (data) {
      const generatedData = gridValuesGenerator({
        startDate: data.startDate ?? new Date(),
        endDate: data.endDate ?? new Date(),
        period: data.period,
        customNumRows: data.customNumRows,
        strictMode: data.strictMode,
        fixedQuantity: data.fixedQuantity
      })
      if (!generatedData.value) {
        // notify error
        setFormDependencies(prevState => ({
          ...prevState,
          error: generatedData.reason
        }))
      } else {
        setData(
          generatedData.value.map((item, idx) => ({
            ...item,
            rowNumber: idx,
            startDate: toLocaleDate(moment(item.startDate).toDate()),
            endDate: toLocaleDate(moment(item.endDate).toDate())
          }))
        )
        setFormDependencies(initialFormDependencies)
        closeForm()
        // setDialogOpen(null)
      }
    } else {
      setFormDependencies(initialFormDependencies)
      closeForm()
      // setDialogOpen(null)
    }
  }

  const handleFormShow = async () => {
    // setDialogOpen('generate')
    openForm({
      definition: generateFormDefinition,
      title: t('translation:components.searchFilter.title'),
      // subtitle,
      mode: FormDialogMode.ADD,
      isWaiting: false,
      onClose: handleGenerateClose
      // okBtnLabel: t('translation:components.searchFilter.actions.ok'),
      // cancelBtnLabel: t('translation:components.searchFilter.actions.cancel'),
      // closeBtnLabel: t('translation:components.searchFilter.actions.cancel')
    })

    setFormDependencies({ ...initialFormDependencies, formState: { period: 3 } })
  }

  const handleEditDialogClose = row => {
    if (row) {
      const formatRow = {
        ...row,
        startDate: toLocaleDate(moment(row.startDate).toDate()),
        endDate: toLocaleDate(moment(row.endDate).toDate())
      }
      const updatedData = data.map(item => {
        return formatRow.rowNumber === item.rowNumber ? formatRow : item
      })
      setData(updatedData)
    }

    setFormDependencies(initialFormDependencies)
    // setDialogOpen(null)
    closeForm()
  }

  const showEditDialog = (row: any) => {
    // setDialogOpen('edit')
    openForm({
      definition: editDialogFormDefinition,
      title: 'Editar fila',
      // subtitle,
      mode: FormDialogMode.EDIT,
      isWaiting: false,
      onClose: handleEditDialogClose
      // okBtnLabel: t('translation:components.searchFilter.actions.ok'),
      // cancelBtnLabel: t('translation:components.searchFilter.actions.cancel'),
      // closeBtnLabel: t('translation:components.searchFilter.actions.cancel'),
      // inputData: {
      //   ...row,
      //   startDate: moment(row.startDate, 'DD/MM/YYYY').toDate(),
      //   endDate: moment(row.endDate, 'DD/MM/YYYY').toDate()
      // }
    })

    setFormDependencies(prevState => ({
      ...prevState,
      formState: {
        ...row,

        quantity: +row.quantity,
        startDate: moment(row.startDate, 'DD/MM/YYYY').toDate(),
        endDate: moment(row.endDate, 'DD/MM/YYYY').toDate()
      }
    }))

    // setFormState({
    //   ...row,
    //   startDate: moment(row.startDate, 'DD/MM/YYYY').toDate(),
    //   endDate: moment(row.endDate, 'DD/MM/YYYY').toDate()
    // })
  }

  const dataGridColumns: DataGridColumn[] = [
    {
      name: 'rowNumber',
      display: false,
      editable: false
    },
    {
      name: 'startDate',
      label: 'Fecha inicio',
      type: DataType.DATE,
      dateFormat: 'DD/MM/YYYY',
      editable: false,
      actions: [
        {
          icon: <Edit fontSize="small" />,
          tooltip: 'Editar fila',
          onClick: (row: any) => {
            showEditDialog(row)
          },
          userPermission: UserPermission.EDIT
        }
      ]
    },
    {
      name: 'endDate',
      label: 'Fecha fin',
      type: DataType.DATE,
      dateFormat: 'DD/MM/YYYY',
      editable: false
    },
    {
      name: 'quantity',
      label: 'Cantidad',
      type: DataType.NUMBER,
      editable: false
    },
    {
      name: 'quantity2',
      label: 'Cantidad2',
      type: DataType.NUMBER,
      editable: false
    },
    {
      name: 'quantity3',
      label: 'Cantidad3',
      type: DataType.NUMBER,
      editable: false
    }
  ]

  const options: DataGridOptions = {
    tableHeight: 600,
    columnWidth: 110,
    elevation: 0,
    roundDecimals: 0
  }

  // useEffect(() => {
  //   if (!!formDependencies.error) {
  //     // setFormState(prevState => ({ ...prevState, errorMessage: null }))
  //     setFormDependencies(prevState => ({
  //       ...prevState,
  //       error: null,
  //       formState: {
  //         ...prevState.formState,
  //         errorMessage: null
  //       }
  //     }))
  //   }
  // }, [formDependencies.formState])

  // useEffect(() => {
  //   console.log('searchFormDefinition', searchFormDefinition)
  //   updateFormDefinition(searchFormDefinition, formDependencies.formState)
  // }, [searchFormDefinition])

  // useEffect(() => {
  //   updateFormDefinition(editDialogFormDefinition, formDependencies.formState)
  // }, [editDialogFormDefinition])

  const formOptions: FormOptions = {
    elevation: 1,
    columns: 2,
    analytics: {
      customer: getCustomerDomain(),
      view: t('pricingDetails:components.editPriceDialog.analytics')
    }
  }

  return (
    <Page>
      <h1>Dates Generator</h1>
      <Button onClick={handleFormShow}>Test</Button>
      <Button disabled={data.length === 0} onClick={() => showEditDialog(data[0])}>
        Edit row 1
      </Button>
      {/* <DataTable data={data} columns={columns} options={tableOptions} /> */}
      <GlobalerisDataGrid
        columns={dataGridColumns}
        data={data}
        options={options}
        userPermissions={[UserPermission.INFO, UserPermission.READ_ONLY, UserPermission.EDIT]}
        readOnlyRowsIndexes={[0]}
        // readOnlyRowsIndexes={pastDatesIndexes}
        // highlightedRowsIndexes={todayIndexes}
        // onGridUpdated={onGridUpdatedHandler}
        // userPermissions={getUserPermissions(Pages.Balance)}
        // info={DataTableErrorHandler(errorProps)}
      />
      <CustomFormDialog {...formProps}></CustomFormDialog>
    </Page>
  )
}
